'use strict';

import { randomString } from './string'

exports.__esModule = true;

var SUCCESS_SUFFIX = "_SUCCESS"
var PROGRESS_SUFFIX = "_PROGRESS"
var FAIL_SUFFIX = "_FAIL"

function createActionChainMiddleware() {
  function actionchain(_ref) {
    var dispatch = _ref.dispatch
    var getState = _ref.getState
    if (actionchain.verbose) console.log("actionchain.factory")
    return function (next) {
      return function (action) {
        //var res =
        if(actionchain.trigger.hasOwnProperty(action.type)) {
          if (actionchain.verbose) console.log(
            "actionchain.trigger",
            action.type
          )
          var chains = actionchain.trigger[action.type]
          for(var j=0; j<chains.length; j++) {
            var chainlink = chains[j]
            if (actionchain.verbose) console.log("chainlink", chainlink)
            // actiom id used to prevent infinite loop...
            if(!action.id) {
              action.id = []
            }
            if (action.id.indexOf(chainlink.id) ==-1) {
              action.id.push(chainlink.id)
              var tasks = chainlink.chain
              for(var i=0; i<tasks.length; i++) {
                var task = tasks[i]
                if(task instanceof Function) {
                  task(dispatch, getState, action)
                } else if (typeof task === "string") {
                  dispatch({id: action.id, type: task, payload: action.payload})
                }
              }
            }
          }
        }
        return next(action)
      }
    }
  }
  actionchain.verbose = false
  actionchain.trigger = {}
  actionchain.chain = function(action, chain) {
    if (actionchain.verbose) console.log("addTrigger", action, chain)
    if (!actionchain.trigger.hasOwnProperty(action)) {
      actionchain.trigger[action] = []
    }
    var chainlink = {id: randomString()} // unique chain id
    if (chain instanceof Array) {
      chainlink.chain = chain
    } else {
      chainlink.chain = [chain]
    }
    actionchain.trigger[action].push(chainlink)
  }
  return actionchain
}

exports['default'] = createActionChainMiddleware;



// WEBPACK FOOTER //
// ./src/app/util/actionchain.js